import { useContext, useState } from "react";

import Popup from "./Popup";
import PopupHeader from "./PopupHeader";
import PopupContent from "./PopupContent";
import { layout as modelFolio } from "apps/HotelFrontdesk/models/folio";
import { layout as modelMaintenance } from "../modelMaintenance";
import { cn } from "tools/ui";
import {
  // borderColor,
  tagsColor,
  tagsColorText,
  channelsImg,
} from "./constants";

const base =
  "flex z-10 rounded-xl h-8 border-[1px] px-1 mx-1 border active:scale-95 cursor-pointer";
const layoutFolio = modelFolio();
const layoutMaint = modelMaintenance();

function RackRecord({ idx, operation, maxDays, handleOpenFolio }) {
  const [openPopup, setOpenPopup] = useState(false);
  let icon = false;

  function getContent(duration) {
    // get inner content of the booking
    let label;
    if (operation.kind === "accommodation") {
      label = operation.guest_name || operation.party || operation.contact;
    } else {
      label = operation.room;
    }
    const style = "text-nowrap pl-1 text-xs my-auto";
    const colorText = tagsColorText[operation.status];
    return (
      <span
        className={cn("overflow-hidden mr-1", style, colorText)}
        key={operation.id}
      >
        {label}
      </span>
    );
  }

  const handleMouse = (value) => {
    setOpenPopup(value);
  };

  const onClick = (event, operation) => {
    let model = "hotel.folio";
    let layout = layoutFolio;
    if (operation.kind === "maintenance") {
      model = "hotel.maintenance";
      layout = layoutMaint;
    }
    handleOpenFolio(operation.id, layout);
    event.stopPropagation();
    event.preventDefault();
  };

  const { duration } = operation;
  if (duration <= 0) return null;

  if (operation.channel_code === "") {
    operation.channel_code = "house";
  }
  const visible = Math.min(duration, maxDays ?? duration);
  const _duration = visible * 4.692 + (visible - 1) * 0.27;
  const _color = tagsColor[operation.status];
  const channelImg = operation.channel_code
    ? channelsImg[operation.channel_code]
    : null;

  if (operation.payments > 0) {
    icon = true;
  }

  return (
    <div
      key={idx}
      onClick={(e) => onClick(e, operation)}
      className={cn(base, _color)}
      onMouseEnter={() => handleMouse(true)}
      onMouseLeave={() => handleMouse(false)}
      style={{ width: _duration + "rem" }}
    >
      {channelImg ? (
        <div className="rounded-full w-6 h-6 py-1">
          <img src={channelImg} />
        </div>
      ) : null}
      {getContent(duration)}
      {icon && <p className="my-auto text-gray-600 ml-auto mr-2">$</p>}
      <Popup
        open={openPopup}
        header={<PopupHeader record={operation} />}
        handleMouseOut={handleMouse}
      >
        <PopupContent operation={operation} />
      </Popup>
    </div>
  );
}

export default RackRecord;
